var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"box"}},[_c('img',{staticStyle:{"width":"500px","height":"390px"},attrs:{"src":require("../assets/loading.gif"),"alt":""}}),_c('p',{staticClass:"tipsText"},[_vm._v("正在进入直播间请稍等...")])])
}]

export { render, staticRenderFns }